require('jquery-validation');
import { addPreloader, removePreloader } from './preloader';
import language from "./lang";

jQuery.validator.addMethod("cirilicValidator", function(value, element) {
    if(value != null && value.match(/^[a-zA-Z0-9]+$/)){
        return false;
    }else{
        return true;
    }
});

// Валидатор
function formValidator(formName, handler) {
    $('#' + formName).validate({
        rules: {
            password: {
                required: true,
                minlength: 6
            },
            password_again: {
                equalTo: "#password"
            },
           
            new_password_again: {
                equalTo: "#newPassword"
            },
            email: {
                required: true,
                email: true
            },
            firstname: {
                required: true,
                cirilicValidator: true
            },
            name: {
                required: true,
                cirilicValidator: true
            },
            surname: {
                required: true,
                cirilicValidator: true
            },
            phone: {
                required: true
            },
            activity: {
                required: true
            },
            comment: {
                required: true
            }
        },
        messages: {
            password: {
                minlength: language('main.validation.password.minlength'),
                required: language('main.validation.password.required')
            },
            password_again: {
                equalTo: language('main.validation.password_again.equalTo')
            },
            new_password_again: {
                equalTo: language('main.validation.password_again.equalTo')
            },
            email: {
                required: language('main.validation.email.required'),
                email: language('main.validation.email.correct')
            },
            name: {
                required: language('main.validation.name.required'),
                cirilicValidator: language('main.validation.name.cirilicValidator')
            },
            firstname: {
                required: language('main.validation.firstname.required'),
                cirilicValidator: language('main.validation.name.cirilicValidator')
            },
            surname: {
                required: language('main.validation.surname.required'),
                cirilicValidator: language('main.validation.name.cirilicValidator')
            },
            phone: { 
                required: language('main.validation.phone.required')
            },
            activity: {
                required: language('main.validation.activity.required')
            },
            comment: {
                required: language('main.validation.comment.required')
            }
        },
        submitHandler: function submitHandler(form) {
            handler(form);
        },
        errorElement: 'span'
    });
}

function successMessage(form, text = 'Наш менеджер свяжется с Вами в ближайшее время', confirm = 'Продолжить', redirect = 'none'){
    Swal.fire({
        title: language('main.modals.basket_success_title'),
        text: text,
        icon: 'success',
        confirmButtonText: confirm,
        showCancelButton: false,
    }).then((result)=>{
        if (result.isConfirmed){
            switch(redirect){
                case 'none':
                    form.reset();
                    break;
                case 'reload':
                    window.location.reload();
                    break;
                default:
                    window.location = redirect;
                    break;
            }
        }else{
            switch(redirect){
                case 'none':
                    form.reset();
                    break;
                case 'reload':
                    window.location.reload();
                    break;
                default:
                    window.location = redirect;
                    break;
            }
        }
    })
}

// window.location.reload()
// Валидация форм
$(document).on('click', '.sendFormBtn', function(e){
    
    let formID = $(this).closest('form').attr('id'),
        form = $(this).closest('form')[0];
    if(!$(this).hasClass('editBtn')){
        formValidator(formID, function (form) {
            addPreloader();
            $.post({
                url: $(form).attr('action') + '/',
                data: $(form).serializeArray(),
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (response) {
                    removePreloader();
                    switch (formID) {
                        case 'feedbackForm_mainPage':
                            if(response.success){
                                successMessage(form, language('main.modals.ajax_success_default'), language('main.modals.button'))
                            }
                        break;
                        
                        case 'feedbackForm_contactsPage':
                            if(response.success){
                                successMessage(form, language('main.modals.ajax_success_default'), language('main.modals.button'))
                            }
                        break;
                        
                        case 'registration_form':
                            if(response['status'] == 'ok'){
                                document.location.href=response.url;
                                successMessage(form, language('auth.registration.success'), undefined, response.url)
                            }
                        break;

                        case 'autorizationForm':
                            if(response){
                                document.location.href=response.url;
                                successMessage(form, language('main.modals.auth_success_title'), undefined, response.url)
                            }
                        break;

                        case 'passwordRecoveryForm':
                            if(response){
                                $.fancybox.close();
                                successMessage(form, language('main.modals.password_recovery_success_title'),language('main.modals.button'))
                            }
                        break;

                        case 'changePasswordForm':
                            if(response){
                                $.fancybox.close();
                                successMessage(form, language('main.modals.change_password_success_title'), language('main.modals.button'))
                            }
                        break;

                        case 'myInfoForm':
                            if(response['status'] == 'ok'){
                                successMessage(form, language('main.modals.ajax_success'), undefined, 'reload')
                            }
                        break;
                        case 'passwordRecoveryForm':
                            if(response['status'] == 'ok'){
                                successMessage(form, language('main.modals.ajax_success'), undefined, 'reload')
                            }
                        break;
                    }
                },
                error: function (response) {
                    removePreloader();
                    switch(formID){
                        case 'registration_form':
                            for (const [key, value] of Object.entries(response.responseJSON.errors)) {
                                console.log(formID);
                                $('label[for="' + formID + '_' + key +'"] input').addClass('error');
                                $('label[for="' + formID + '_' + key +'"]').append('<span class="error">' + value + '</span>');
                            }
                            break;        
                            //response.responseJSON.errors.forEach((element) => console.log(element));
                            //console.log(response.responseJSON.errors);
                            //Swal.fire({
                            //    title: language('main.modals.popup_error_title'),
                            //    text: language('main.modals.popup_error_text'),
                            //    icon: 'error',
                            //    confirmButtonText: language('main.modals.popup_error_confirm'),
                            //    showCancelButton: false,
                            //});
                        break;
                        default:
                            Swal.fire({
                                title: language('main.modals.popup_error_title'),
                                text: language('main.modals.popup_error_text'),
                                icon: 'error',
                                confirmButtonText: language('main.modals.popup_error_confirm'),
                                showCancelButton: false,
                            });
                        break;
                    }
                    
                }
            })
        })
    }else{
        $(this).val($(this).data('value'));
        $(this).removeClass('editBtn');
        $(this).closest('form').removeClass('noEdit')
        return false;
    }    
})